import type { WallBlockingType, DoorState } from '@roll1/shared';

export interface WallStyle {
  color: string;
  lineWidth: number;
  lineDash: number[];
}

export function getWallStyle(blocking: WallBlockingType, doorState?: DoorState): WallStyle {
  switch (blocking) {
    case 'door':
      switch (doorState) {
        case 'open':
          return { color: '#F59E0B', lineWidth: 2, lineDash: [8, 4] };
        case 'locked':
          return { color: '#EF4444', lineWidth: 3, lineDash: [] };
        case 'closed':
        default:
          return { color: '#F59E0B', lineWidth: 3, lineDash: [] };
      }
    case 'window':
      return { color: '#3B82F6', lineWidth: 2, lineDash: [6, 3, 2, 3] };
    case 'terrain':
      return { color: '#22C55E', lineWidth: 2, lineDash: [6, 4] };
    case 'secret':
      return { color: '#A855F7', lineWidth: 2, lineDash: [2, 4] };
    case 'ethereal':
      return { color: '#6B7280', lineWidth: 1, lineDash: [2, 6] };
    case 'wall':
    default:
      return { color: '#9CA3AF', lineWidth: 3, lineDash: [] };
  }
}

/** Highlight color for hovered/selected walls */
export const WALL_HIGHLIGHT_COLOR = '#FFFFFF';
export const WALL_HIGHLIGHT_WIDTH_ADD = 2;
